console.log("IMLOADED");
checkoutUrl = window.location.protocol + '//' + window.location.hostname + '/checkout?';


window.addEventListener("breezeBroadcast", (event) => {
  const eventData = event.detail;
  window.cartData = eventData.value;
});

function clickNative(location){
  const breezeButton = document.querySelectorAll(`[data-button-location=${location}]`);
  const parentElement = breezeButton[0].parentElement;
  const checkoutButton = parentElement.querySelector('button[type="button"]')
  checkoutButton.click();
}

async function onProductPage(props){
  try{
    let cartItems = null;
    const decodedProps = atob(props);
    const jsonProps = JSON.parse(decodedProps);
    console.log(">>>>", "prince props2", jsonProps)
    if (jsonProps !== null){
      cartItems = [jsonProps];
    }
    if (cartItems !== null && cartItems.length > 0){
      if (window.shopifyVariables?.isB2BCustomer) {
          console.log("redirect to native1")
          await clickNative('product')
          // window.location.href = checkoutUrl;
          return false;
        }
      // window.openBreezeCheckout();
      return true;
    }
  }catch(e){
    console.error("Breeze| Exception| onProductPage: ",e)
  }
  await clickNative('product');
  return false;
}

window.breeze = {
  onCheckoutButtonClick: async (props) => {
    let cartItems = null;
    try{
      if (props !== null){
        const res = await onProductPage(props)
        return res;
      }else{
        if (window.shopifyVariables?.isB2BCustomer) {
          window.location.href = checkoutUrl;
          return false;
        }
        // window.openBreezeCheckout();
        return true;
      }
    } catch(e){
      console.error("Breeze| Exception| onCart: ",e)
    }
    window.location.href = checkoutUrl;
    return false;
  }
};
